module.exports = {"511702001":"东城街道","511702002":"西城街道","511702003":"朝阳街道","511702100":"西外镇","511702101":"北外镇","511702102":"罗江镇","511702103":"蒲家镇","511702104":"复兴镇","511702105":"双龙镇","511702106":"魏兴镇","511702107":"江陵镇","511702108":"碑庙镇","511702109":"磐石镇","511702110":"东岳镇","511702111":"梓桐镇","511702112":"北山镇","511702113":"金石镇","511702202":"新村乡","511702203":"檬双乡","511702204":"龙滩乡","511702208":"安云乡","511702209":"青宁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511702.json
// module id = 2188
// module chunks = 0